export interface CallbackForm {
  phone?: string;
  comment?: string;
  address?: string;
  isRoofInstalled?: boolean;
}

export interface CallbackBody extends CallbackForm {
  type: CallbackType;
}

export enum CallbackType {
  CALLBACK = 'CALLBACK',
  PHONEORDER = 'PHONEORDER',
  ERRORREPORT = 'ERRORREPORT',
  TRANSITPRICE = 'TRANSITPRICE',
  DESIGNREQUEST = 'DESIGNREQUEST',
  ROOFREQUEST = 'ROOFREQUEST',
  SMARTHOMEREQUEST = 'SMARTHOMEREQUEST',
}
